import {
  Badge,
  IconChevron,
  Link,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Text,
} from 'braid-design-system';

import type { SalaryRangeByRole } from '../../../pages/salaries/salariesTabModel';

type MobileSalariesListProps = {
  label: string;
  paginatedSalaryRanges: SalaryRangeByRole[];
  salariesPagePath: string;
  trackRoleClicked: (roleTitle: string) => void;
};

export const MobileSalariesList = ({
  paginatedSalaryRanges,
  label,
  trackRoleClicked,
  salariesPagePath,
}: MobileSalariesListProps) => (
  <Table label={label}>
    <TableBody>
      {paginatedSalaryRanges.map((item) => {
        const salaryRangeLabel =
          item.rangeByCompany?.label || item.rangeByIndustry?.label;
        return salaryRangeLabel ? (
          <TableRow key={item.roleId}>
            <TableCell wrap width="30%">
              <Link
                href={`${salariesPagePath}/${item.roleId}`}
                onClick={() => trackRoleClicked(item.roleTitle)}
              >
                <Text weight="medium" maxLines={2}>
                  {item.roleTitle}
                </Text>
              </Link>
            </TableCell>
            <TableCell align="left" width="content">
              <Link
                href={`${salariesPagePath}/${item.roleId}`}
                onClick={() => trackRoleClicked(item.roleTitle)}
              >
                <Badge tone="info">{salaryRangeLabel}</Badge>
              </Link>
            </TableCell>
            <TableCell width="content">
              <Link
                href={`${salariesPagePath}/${item.roleId}`}
                onClick={() => trackRoleClicked(item.roleTitle)}
              >
                <IconChevron size="xsmall" direction="right" />
              </Link>
            </TableCell>
          </TableRow>
        ) : null;
      })}
    </TableBody>
  </Table>
);
